<template>
  <div>
    <rabbey-toolbox
      :call-new="IsInRole(roles.GerenteRRHH) === true ? callNew : undefined"
      filterables
      @filter-search="onFilterSearch"
    />
    <!-- <h1>{{ activInac2 }}</h1> -->
    <el-select
      style="position: relative; bottom: 36px; left: 885px"
      v-model="activInac2"
      size="mini"
      placeholder="Activos&Inactivos"
      clearable
      filterable
    >
      <el-option
        v-for="actEinac in ActiAndOul2"
        :key="actEinac.Value"
        :label="actEinac.Label"
        :value="actEinac.Value"
      >
      </el-option>
    </el-select>
    <rabbey-table2
      ref="rTable"
      index-url="/api/deparments/all2"
      :paginate-from-api="false"
      :columns="columns"
      :actions="actions"
      :custList="custList"
      :search="search"
      :default-params="getParams"
      @rtable-push-action="handleCommand"
    />

    <el-drawer
      :title="title"
      :visible.sync="drawer"
      employee="rtl"
      :destroy-on-close="true"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col :span="24">
              <el-form
                ref="form"
                :model="form"
                label-position="left"
                size="mini"
                label-width="120px"
                :rules="rules"
              >
                <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="form.Name"
                    :disabled="formAction === 'view'"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="Direccion" prop="DirecctionID">
                  <el-select
                    v-model="form.DirecctionID"
                    placeholder="Select Direccion"
                    filterable
                    :disabled="formAction === 'view'"
                  >
                    <el-option
                      v-for="dir in directions"
                      :key="dir.DirecctionID"
                      :value="dir.DirecctionID"
                      :label="dir.DirecctionName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="Direccion" prop="DirecctionID">
                  <el-select
                    v-model="form.DirecctionID"
                    :disabled="formAction === 'view'"
                    filterable
                    allow-create
                    placeholder="Select Direccion"
                  >
                    <el-option
                      v-for="dir in directions"
                      :key="dir.DirecctionID"
                      :value="dir.DirecctionID"
                      :label="dir.DirecctionName"
                    >
                    </el-option>
                  </el-select>
                  <!-- <el-input
                          v-model="form.Profesion"
                          :disabled="formAction === 'view'"
                        ></el-input> -->
                </el-form-item>
                <el-form-item label="Encargado" prop="SupervisorId">
                  <EmployeeSelector
                    :placeholder="'Encargado'"
                    v-model="form.SupervisorId"
                    @selection-change="updateSelectedEmployee"
                    @list-employee="employeList = $event"
                  />
                  <!-- <el-select
                    v-model="form.SupervisorId"
                    placeholder="Select Encargado"
                    filterable
                    :disabled="formAction === 'view'"
                  >
                    <el-option
                      v-for="pro in profiles"
                      :key="pro.Id"
                      :value="pro.Id"
                      :label="`${pro.Name} ${pro.LastName}`"
                    >
                    </el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="onSubmit(formAction)"
                    v-loading="drawerLoading"
                    v-if="formAction !== 'view'"
                    >{{ labelButton }}</el-button
                  >
                  <el-button @click="onCancel">Cancel</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
// import ImagePersonByEmployee from "@/components/functionals/ImagePersonByEmployee.vue";

export default {
  name: "DepartamentList",
  components: {
    EmployeeSelector
  },
  data() {
    return {
      search: "",
      profiles: [],
      loading: false,
      l2: false,
      departmentId: 2,
      productId: 0,
      serviceRequestTypeId: 0,
      technicalId: 0,
      activInac2: true,
      companyCode: "",
      items: [],
      custList: [],
      DireccionSelected: [],
      drawer: false,
      title: "",
      labelButton: "Crear",
      drawerLoading: false,
      detail: {
        id: 0,
        clientCode: ""
      },
      formAction: "create",
      form: {
        Id: 0,
        Name: "",
        CompanySelected: "",
        DirecctionID: "",
        Direccion: "",
        SupervisorId: "",
        isEneable: true
      },
      modelDireccion: "",
      directions: [],
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        CompanySelected: [{ required: true, message: "Empresa es requerido" }],
        DirecctionID: [{ required: true, message: "Direccion es requerida" }],
        SupervisorId: [
          { required: true, message: "El Supervisor es requerida" }
        ]
      },
      columns: [
        {
          fixed: true,
          prop: "ID",
          name: "NO",
          width: 80
        },
        {
          prop: "Name",
          name: "Nombre Departamento",
          width: 400
        },
        {
          pro: "Direccion.Name",
          name: "Direccion",
          width: 400,
          formatter: (row) => row.Direccion.Name
        },
        {
          pro: "Encargado",
          name: "Encargado",
          width: 400,
          formatter: (row) => row.Encargado.Name
        },
        {
          prop: "CreatedAt",
          name: "Fecha",
          width: 110,
          formatter: (row) => {
            return formatDate(row.CreatedAt, "DD/MM/YYYY");
          }
        }
      ],
      actions: [
        // {
        //   icon: "el-icon-view",
        //   label: "Ver",
        //   command: "view"
        // },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-circle-check",
          label: "Activar",
          command: "activate",
          condition: (t) => t.isEnable === false
        },
        {
          icon: "el-icon-remove-outline",
          label: "Desactivar",
          command: "outline",
          condition: (t) => t.isEnable === true
        }
      ],
      ActiAndOul2: [
        { Label: "Activos", Value: true },
        { Label: "Inactivos", Value: false },
        { Label: "Todas", Value: 3 }
      ]
    };
  },
  computed: {
    getParams() {
      return {
        companyId: this.currentCompany,
        isEne: this.activInac2
      };
    },
    isManageHHRR() {
      return this.IsInRole(this.roles.GerenteRRHH);
    }
  },
  methods: {
    formatDate,
    updateSelectedEmployee(val) {
      this.form.SupervisorId = val;
    },
    onFilterSearch(s) {
      this.search = s;
    },
    callNew() {
      this.callForm("create");
    },
    getData() {
      this.loading = true;

      this.$http
        .get("/api/deparments/all", {
          params: {
            companyID: this.companyCode
          }
        })
        .then((resp) => {
          this.loading = false;
          this.items = resp.data;
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getDirections() {
      this.$http
        .get("/api/Directions", {
          params: {
            CompanySelected: this.companyCode
          }
        })
        .then((resp) => {
          this.directions = resp.data;
          //console.log("wowww directions", this.directions);
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    // getProfiles() {
    //   this.$http
    //     .get("/api/Profilers/GetByCompany", {
    //       params: {
    //         companyId: this.companyCode
    //       }
    //     })
    //     .then(resp => {
    //       this.profiles = resp.data;
    //     })
    //     .catch(err => {
    //       this.$alert(err.message, err.name, {
    //         type: "error"
    //       });
    //     });
    // },
    getDataById(id) {
      const l = this.$loading({
        text: "Cargando datos"
      });

      this.$http
        .get(`/api/deparments/${id}`)
        .then((resp) => {
          this.form = resp.data;
          this.drawer = true;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          l.close();
        });
    },

    onSubmit(action) {
      // validar el form
      this.$refs.form.validate((valid) => {
        if (valid) {
          // Peticion de creacion
          if (action === "create") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .post("/api/deparments", {
                Name: this.form.Name,
                DirecctionID: this.form.DirecctionID,
                SupervisorId: this.form.SupervisorId,
                companyID: this.companyCode
              })
              .then(() => {
                this.drawer = false;
                this.message({
                  type: "success",
                  message: "Creado"
                });
                this.columns();
              })
              .catch(() => {
                this.message.error("Erro!");
                this.loading_form = false;
              })
              .finally(() => {
                this.loading_form = false;
                this.drawerLoading = false;
                this.$refs.rTable.initialTable();
                this.form = {};
              });
          } else if (action === "edit") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .put(`/api/deparments/${this.form.Id}`, this.form)
              .then(() => {
                this.drawer = false;
                // this.form = {};
                this.$message({
                  type: "success",
                  message: "Actualizado"
                });
              })
              .catch(() => {
                this.message.error("Erro!");
              })
              .finally(() => {
                this.drawer = false;
                this.loading_form = false;
                this.drawerLoading = false;
                // this.form = {};
                this.$refs.rTable.initialTable();
              });
          }
        } else {
          this.drawer = true;
          return false;
        }
      });
    },
    callForm(type) {
      if (type === "create") {
        this.form = {
          Name: "",
          CompanySelected: "",
          DirecctionID: "",
          Direccion: "",
          SupervisorId: ""
        };
        this.title = `Crear Departamento`;
        this.formAction = "create";
        this.drawer = true;
      }
    },
    onCancel() {
      //this.form = { SupervisorId: 0 };
      this.$refs.form.resetFields;
      this.drawer = false;
      this.drawerLoading = false;
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    handleBeforeClose(done) {
      this.$refs.form.resetFields;
      done();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getData();
    },
    handleCommand(option) {
      const isValid = this.IsInRole(this.roles.GerenteRRHH);
      // console.log(option)
      if (
        (option.command === "edit" && !isValid) ||
        (option.command === "view" && !isValid)
      ) {
        this.$message.warning("Lo sentimos usted no tiene acceso");
      } else {
        switch (option.command) {
          case "view": {
            this.title = `Ver - ${option.row.Name}`;
            this.formAction = "view";
            this.getDataById(option.row.ID);

            break;
          }
          case "edit": {
            this.title = `Editar - ${option.row.Name}`;
            this.labelButton = "Editar";
            this.formAction = "edit";
            this.drawer = true;
            this.form.Name = option.row.Name;
            this.form.DirecctionID = option.row.Direccion.Id;
            this.form.SupervisorId = option.row.Encargado.Id;
            this.form.Id = option.row.ID;
            // console.log("klk data", this.form);
            // console.log("wowww directions", this.directions);

            break;
          }
          case "outline": {
            const { ID } = option.row;
            const params = {
              id: ID
            };
            this.$http
              .put(`/api/deparments/Enabled`, params)
              .then(() => {
                // this.form = {};
                this.$message({
                  type: "success",
                  message: "Actualizado"
                });
                this.$refs.rTable.refreshTable();
              })
              .catch(() => {
                this.message.error("Erro!");
              });
            break;
          }
          case "activate": {
            const { ID } = option.row;
            const params = {
              id: ID
            };
            this.$http
              .put(`/api/deparments/Enabled`, params)
              .then(() => {
                // this.form = {};
                this.$message({
                  type: "success",
                  message: "Actualizado"
                });
                this.$refs.rTable.refreshTable();
              })
              .catch(() => {
                this.message.error("Erro!");
              });
            break;
          }
          default:
            this.formAction = "create";
            break;
        }
      }
    },
    clickCreate() {
      this.title = "Crear Departamento";
      this.form = {
        Name: "",
        CompanySelected: "",
        DirecctionID: "",
        ProfilesID: "",
        SupervisorId: ""
      };
      this.drawer = true;
    }
  },
  mounted() {
    this.companyCode = this.currentCompany;

    this.getDirections();
    // this.getProfiles();
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #3c3c3c;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
